import cx from 'classnames';

import {Icon, IconName} from 'components';

type Props = {
    disabled?: boolean;
    className?: string;
    onChange: () => void;
    iconName: IconName
}

export const InputNumberControl: React.FC<Props> = ({disabled, iconName, className, onChange}) => (
    <Icon
        disabled={disabled}
        className={cx('tw-border-2', className)}
        button
        group
        size='lg'
        thickness='xl'
        name={iconName}
        onClick={onChange}
    />
);